import FrequencySelect from 'components/FrequencySelect';
import { Grid, SelectChangeEvent, TextField } from '@mui/material';
import { ChangeEvent } from 'react';

interface Props {
  crossPolCenter: { value: string; unit: string };
  handleCrossPolCenterValueChanged: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleCrossPolCenterUnitChanged: (event: SelectChangeEvent<string>) => void;
}

const CrosspolFreqOffset = ({
  crossPolCenter,
  handleCrossPolCenterValueChanged,
  handleCrossPolCenterUnitChanged,
}: Props) => {
  return (
    <Grid container>
      <Grid item xs>
        <TextField
          variant='outlined'
          required
          fullWidth
          type='number'
          inputProps={{ min: '1', step: '1' }}
          size='small'
          id='value'
          label='Cross-Pol Center'
          name='value'
          value={crossPolCenter.value}
          onChange={handleCrossPolCenterValueChanged}
        />
      </Grid>
      <Grid item xs>
        <FrequencySelect
          name='unit'
          selected={crossPolCenter.unit}
          onChange={handleCrossPolCenterUnitChanged}
        />
      </Grid>
    </Grid>
  );
};

export default CrosspolFreqOffset;
